import React from 'react';
import { Building2, Factory, Zap } from 'lucide-react';

/**
 * Компонент для базовой информации о проекте трансформации
 */
const BasicInformationSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  transformationTypes,
  companySizes,
  industryTypes
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Размер компании */}
      <div>
        <label htmlFor="companySize" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Building2 className="w-4 h-4 mr-2 text-indigo-500" />
          Размер компании
        </label>
        <select
          id="companySize"
          name="companySize"
          value={formData.companySize}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.companySize ? 'input-error' : ''}`}
        >
          {companySizes.map((size) => (
            <option key={size.id} value={size.id}>
              {size.name} ({size.description})
            </option>
          ))}
        </select>
        {errors.companySize && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.companySize}
          </p>
        )}
      </div>

      {/* Отрасль */}
      <div>
        <label htmlFor="industryType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Factory className="w-4 h-4 mr-2 text-indigo-500" />
          Отрасль
        </label>
        <select
          id="industryType"
          name="industryType"
          value={formData.industryType}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.industryType ? 'input-error' : ''}`}
        >
          {industryTypes.map((industry) => (
            <option key={industry.id} value={industry.id}>
              {industry.name}
            </option>
          ))}
        </select>
        {errors.industryType && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.industryType}
          </p>
        )}
      </div>

      {/* Тип трансформации */}
      <div className="md:col-span-2">
        <label htmlFor="transformationType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Zap className="w-4 h-4 mr-2 text-indigo-500" />
          Тип трансформации бизнес-процессов
        </label>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 mt-2">
          {transformationTypes.map((type) => (
            <div
              key={type.id}
              className={`p-3 rounded-lg border cursor-pointer transition-colors
                ${formData.transformationType === type.id
                  ? 'bg-indigo-50 border-indigo-300 text-indigo-700 dark:bg-indigo-900/30 dark:border-indigo-700 dark:text-indigo-300'
                  : 'bg-white border-gray-200 text-gray-700 hover:bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-700'
                }`}
              onClick={() => handleInputChange({
                target: { name: 'transformationType', value: type.id }
              })}
            >
              <div className="font-medium text-sm">{type.name}</div>
              <div className="text-xs mt-1 opacity-75">{type.description}</div>
            </div>
          ))}
        </div>
        {errors.transformationType && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.transformationType}
          </p>
        )}
      </div>
    </div>
  );
};

export default BasicInformationSection;